<template>
  <div class="employList">   <!--新闻列表-->
    <breadcrumb class="breadcrumb"/>
    <el-row class="main-container">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <el-form :inline="true" class="demo-form-inline" size="small" >
            <el-form-item label="职位：">
              <el-input v-model="position" placeholder="输入标题" @keyup.enter.native="onSubmit" clearable></el-input>
            </el-form-item>
            <el-form-item label="部门：">
              <el-select v-model="department_search" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item style="margin-left: 15px">
              <el-button type="primary" @click="onSubmit" icon="el-icon-search">查询</el-button>
            </el-form-item>
            <div class="treeOption">
              <el-button type="success" size="small" icon="el-icon-plus" @click="addEmploy">新增</el-button>
              <el-button type="danger" size="small" icon="el-icon-delete" @click="deleteEmploy">删除</el-button>
            </div>
          </el-form>
        </div>
        <div class="tableCenter">
          <el-table
            :data="employList"
            style="width: 100%" border
            @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              type="index">
            </el-table-column>
            <el-table-column
              prop="position"
              label="职位"
              >
            </el-table-column>
            <el-table-column
              prop="departmentname"
              label="部门"
            >
            </el-table-column>
            <el-table-column
              prop="isValidVal"
              label="是否在招">
            </el-table-column>
            <el-table-column
              label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="modifyEmploy(scope.row)">修改</el-button>
                <el-button type="text" @click="modifyValid(scope.row)" v-if="scope.row.isValid == 0">开始招聘</el-button>
                <el-button type="text" @click="modifyValid(scope.row)" v-else>停止招聘</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="margin-top: 15px;float: right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNo"
            :page-sizes="[20, 50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount">
          </el-pagination>
        </div>
      </el-card>
    </el-row>
    <!--新增dialog-->
    <el-dialog
      :title="employTitleName"
      :visible.sync="dialogAddChange"
      width="800px"
      :close-on-click-modal="false"
      class="top">
      <div>
        <el-form ref="form" :model="formResult" label-width="100px">
          <el-form-item label="职位：">
            <el-input v-model="formResult.position"></el-input>
          </el-form-item>
          <el-form-item label="部门：">
            <el-select v-model="formResult.department" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="技能要求：">
            <el-input v-model="formResult.require"></el-input>
          </el-form-item>
          <el-form-item label="开始招聘：">
            <el-radio-group v-model="formResult.isValid">
              <el-radio label="0">否</el-radio>
              <el-radio label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="岗位职责：">
            <div v-for="(list,index) in formResult.duty" :key="index">
              <el-form label-width="20px">
                <el-row>
                  <el-col :span="20">
                    <el-form-item :label="`${index+1}、`">
                      <el-input v-model="formResult.duty[index]"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1" :offset="1">
                      <div style="display: flex;">
                        <el-button icon="el-icon-plus" circle v-show="index+1 === formResult.duty.length" @click="addDuty" size="mini" style="position: relative;top: 5px"></el-button>
                      </div>
                  </el-col>
                  <el-col :span="1" :offset="1">
                    <div style="display: flex;">
                      <el-button icon="el-icon-minus" circle  @click="removeDuty(index)" size="mini" style="position: relative;top: 5px" v-show="index > 0"></el-button>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-form-item>
          <el-form-item label="任职资格：">
            <div v-for="(list,index) in formResult.qualification" :key="index">
              <el-form label-width="20px">
                <el-row>
                  <el-col :span="20">
                    <el-form-item :label="`${index+1}、`">
                      <el-input v-model="formResult.qualification[index]"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1" :offset="1">
                      <div style="display: flex;">
                        <el-button icon="el-icon-plus" circle v-show="index+1 === formResult.qualification.length" @click="addQualification" size="mini" style="position: relative;top: 5px"></el-button>
                      </div>
                  </el-col>
                  <el-col :span="1" :offset="1">
                    <div style="display: flex;">
                      <el-button icon="el-icon-minus" circle  @click="removeQualification(index)" size="mini" style="position: relative;top: 5px" v-show="index > 0"></el-button>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-form-item>
          <el-form-item label="福利待遇：">
            <div v-for="(list,index) in formResult.pay" :key="index">
              <el-form label-width="20px">
                <el-row>
                  <el-col :span="20">
                    <el-form-item :label="`${index+1}、`">
                      <el-input v-model="formResult.pay[index]"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1" :offset="1">
                      <div style="display: flex;">
                        <el-button icon="el-icon-plus" circle v-show="index+1 === formResult.pay.length" @click="addPay" size="mini" style="position: relative;top: 5px"></el-button>
                      </div>
                  </el-col>
                  <el-col :span="1" :offset="1">
                    <div style="display: flex;">
                      <el-button icon="el-icon-minus" circle  @click="removePay(index)" size="mini" style="position: relative;top: 5px" v-show="index > 0"></el-button>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogAddChange = false">取 消</el-button>
        <el-button type="primary" @click="submitEmploy">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        employTitleName:'',
        dialogAddChange:false,
        position:'',
        employList:[],
        isadd:true,
        formResult:{ID:'',position:'',department:'',isValid:'1',require:'',duty:[''],qualification:[''],pay:['']},
        multipleSelection: [],
        pageSize:20,
        pageNo:1,
        totalCount:0,
        options: [{
          value: '1',
          label: 'IT部'
        }, {
          value: '2',
          label: '实验室'
        }, {
          value: '3',
          label: '销售部'
        }],
        department_search: '',
        department:'',
      };
    },
    mounted() {
      this.init();
    },
    methods: {
      init(){
        let vm =this;
        let params = {
          position:vm.position,
          department: vm.department_search,
          pageNo:vm.pageNo,
          pageSize:vm.pageSize,
          comefrom:'1' //后台管理查看所有记录
        }
        vm.axios.get('/employ/queryEmployList', {params: params})
          .then(res => {
            vm.employList = [];
            res.data.employList.list.forEach((val)=>{
              if(val.department == '1'){
                val.departmentname = 'IT部';
              }else if(val.department == '2'){
                val.departmentname = '实验室';
              }else if(val.department == '3'){
                val.departmentname = '销售部';
              }
              val.isValidVal = val.isValid == 1 ? '是' : '否';
              val.duty = val.duty.split('|');
              val.qualification = val.qualification.split('|');
              val.pay = val.pay.split('|');
              vm.employList.push(val);
            })
            vm.totalCount = res.data.employList.count[0].count;
          }).catch(error => {
        })
      },
      //查询
      onSubmit(){
        this.init();
      },
      //pageSize改变事件
      handleSizeChange(val){
        let vm =this;
        vm.pageSize = val;
        vm.pageNo = 1;
        this.init();
      },
      //pageNo改变事件
      handleCurrentChange(val){
        let vm =this;
        vm.pageNo = val;
        this.init();
      },
      //新增
      addEmploy(){
        let vm =this;
        vm.isadd = true;
        vm.formResult.position ='';
        vm.formResult.department = '';
        vm.formResult.isValid = '1';
        vm.formResult.require = '';
        vm.formResult.duty = [''];
        vm.formResult.qualification = [''];
        vm.formResult.pay = [''];
        vm.menuTitleName = '新增';
        vm.dialogAddChange = true;
      },
      //修改
      modifyEmploy(row){
        let vm = this;
        vm.isadd = false;
        vm.menuTitleName = '修改';
        vm.formResult.ID = row.ID;
        vm.formResult.position = row.position;
        vm.formResult.department = row.department;
        vm.formResult.isValid = row.isValid.toString();
        vm.formResult.require = row.require;
        vm.formResult.duty = row.duty;
        vm.formResult.qualification = row.qualification;
        vm.formResult.pay = row.pay;
        vm.dialogAddChange = true;
      },
      submitEmploy(){
        let vm =this;
        let params = {};
        params.position = vm.formResult.position;
        params.department = vm.formResult.department;
        params.isValid = vm.formResult.isValid;
        params.require = vm.formResult.require;
        params.duty = vm.formResult.duty;
        params.qualification = vm.formResult.qualification;
        params.pay = vm.formResult.pay;
        if(vm.isadd){
          vm.axios.post('/employ/saveEmploy', {params: params})
          .then(res => {
            if(res.data.resultCode === '00'){
              vm.init();
              vm.dialogAddChange = false;
              this.$message({
                showClose: true,
                message: '添加成功',
                type: 'success'
              });
            }
          }).catch(error => {
            this.$message({
              showClose: true,
              message: '添加失败',
              type: 'error'
            });
          })
        }else{
          params.ID = vm.formResult.ID;
          vm.axios.post('/employ/modifyEmploy', {params: params})
          .then(res => {
            if(res.data.resultCode === '00'){
              vm.init();
              vm.dialogAddChange = false;
              this.$message({
                showClose: true,
                message: '修改成功',
                type: 'success'
              });
            }
          }).catch(error => {
            this.$message({
              showClose: true,
              message: '修改失败',
              type: 'error'
            });
          })
        }
      },
      deleteEmploy(){
        let vm =this;
        if(vm.multipleSelection.length > 0){
          this.$confirm('确定要删除所选内容吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            vm.axios.post('/employ/deleteEmploy', {params: vm.multipleSelection})
            .then(res => {
              if(res.data.resultCode === '00'){
                vm.init();
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success'
                });
              }
            }).catch(error => {
              this.$message({
                showClose: true,
                message: '删除失败',
                type: 'error'
              });
            })
          }).catch(() => {
          });
        }else{
          this.$message({
            showClose: true,
            message: '请选择需要删除的内容',
            type: 'warning'
          });
        }
      },
      
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      
      //增加岗位职责
      addDuty(){
        let vm =this;
        let obj = '';
        vm.formResult.duty.push(obj);
      },
      //删除岗位职责
      removeDuty(key){
        let vm =this;
        vm.formResult.duty.splice(key,1);
      },

      //增加任职资格
      addQualification(){
        let vm =this;
        let obj = '';
        vm.formResult.qualification.push(obj);
      },
      //删除任职资格
      removeQualification(key){
        let vm =this;
        vm.formResult.qualification.splice(key,1);
      },

      //增加福利待遇
      addPay(){
        let vm =this;
        let obj = '';
        vm.formResult.pay.push(obj);
      },
      //删除福利待遇
      removePay(key){
        let vm =this;
        vm.formResult.pay.splice(key,1);
      },
      modifyValid(row){
        let vm =this;
        let confirmContent = row.isValid == '1' ? '确定要停止招聘吗?' : '确定要开始招聘吗?';
        this.$confirm(confirmContent, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          vm.axios.post('/employ/modifyValid', {params: {ID:row.ID, isValid:row.isValid}})
          .then(res => {
            if(res.data.resultCode === '00'){
              vm.init();
              this.$message({
                showClose: true,
                message: '操作成功',
                type: 'success'
              });
            }
          }).catch(error => {
            this.$message({
              showClose: true,
              message: '操作失败',
              type: 'error'
            });
          })
        }).catch(() => {
        });
      },
    },
  }
</script>

<style scoped lang="scss">
  .employList{
    .main-container{
      .tableCenter{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/management/employList.vue